module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_m_albino.d79b6d9c.png";